import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const connectOrdersAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ConnectOrdersView, Permission.ConnectOrdersModify],
  warehouseFeatureToggles: [FeatureToggle.connectOrders],
  notFeatureToggles: [FeatureToggle.hideLmdDashboard],
}
